/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Billing_Alltime_PaidInputs */



/**
* | output |
* | --- |
* | "Paid" |
*
* @param {Admin_Billing_Alltime_PaidInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_billing_alltime_paid = /** @type {((inputs?: Admin_Billing_Alltime_PaidInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Billing_Alltime_PaidInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Bezahlt")
	return /** @type {LocalizedString} */ ("Paid")
});